var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.494,
    height: 12,
    viewBox: "0 0 10.494 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_672",
    "data-name": "Rect\\xE1ngulo 672",
    width: 10.494,
    height: 12,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advertencia_02",
    "data-name": "Advertencia 02",
    transform: "translate(13.992 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3812",
    "data-name": "Grupo 3812",
    transform: "translate(-13.992 -6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M10.274,1.844a19.715,19.715,0,0,1,.22,2.9,7.552,7.552,0,0,1-5.005,7.2H5.005A7.545,7.545,0,0,1,0,4.742,20.2,20.2,0,0,1,.263,1.405.7.7,0,0,1,.571.966C1.01.659,2.327,0,5.225,0S9.484.659,9.879.966l.132.132-.746.351a9.009,9.009,0,0,0-4.04-.7,10.571,10.571,0,0,0-4.259.79A20.856,20.856,0,0,0,.7,4.7a6.894,6.894,0,0,0,4.566,6.586A6.894,6.894,0,0,0,9.791,4.7a18.046,18.046,0,0,0-.176-2.547Z",
    transform: "translate(0)",
    fill: "#1a1446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cerrar_pop_up",
    "data-name": "Cerrar pop up",
    transform: "translate(3.122 3.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    "data-name": "Trazado 100",
    d: "M41.853,41.025l-1.088-1.1,1.1-1.088a.291.291,0,0,0,0-.409l-.528-.533a.291.291,0,0,0-.409,0l-1.1,1.088-1.088-1.1a.291.291,0,0,0-.409,0l-.533.528a.291.291,0,0,0,0,.409l1.088,1.1-1.1,1.088a.291.291,0,0,0,0,.409l.528.533a.291.291,0,0,0,.409,0l1.1-1.088,1.088,1.1a.291.291,0,0,0,.409,0l.533-.528A.3.3,0,0,0,41.853,41.025Z",
    transform: "translate(-37.7 -37.8)",
    fill: "#1a1446"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldError);
export default __webpack_public_path__ + "static/media/shieldError.5062c532e97b1b2e99eb46601e7e75a7.svg";
export { ForwardRef as ReactComponent };